import { render, staticRenderFns } from "./SortingDevices.vue?vue&type=template&id=4581b858&"
import script from "./SortingDevices.vue?vue&type=script&lang=js&"
export * from "./SortingDevices.vue?vue&type=script&lang=js&"
import style0 from "./SortingDevices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports